import React from "react";

interface Props {
	children: React.ReactNode;
}
interface State {
	hasError: boolean;
}
class ErrorBoundary extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error: Error): State {
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
		console.error("Error caught by Error Boundary:", error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			// You can return any custom fallback UI
			return <h1>Something went wrong. Please try again later.</h1>;
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
